exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GbKnlrcyAfdgFr9WpTgdU{display:inline;overflow:hidden;text-overflow:ellipsis;vertical-align:top}._38M2cFZvI3zeoqdPO7XTtg{font-weight:600}", ""]);

// exports
exports.locals = {
	"recipientContent": "_1GbKnlrcyAfdgFr9WpTgdU",
	"groupOrDl": "_38M2cFZvI3zeoqdPO7XTtg"
};